import React, { useEffect, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/DataView/DataViewDemo.css";
import "../../../assets/DataView/index.css";
import "../../../assets/css/AccordionDemo.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import jsPDF from "jspdf";
import logoBig from "../../../assets/logo1.png";
import { FilterMatchMode } from 'primereact/api';
import { getBankAccount, getBanker } from "../../../services/userMasterUser";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { formatDate } from "../../../constants/FormateDate";
import { bankerListUpload } from "../../../services/bankListUpload";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";

export default function BankAccountList() {

  const navigate = useNavigate();

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(20);
  const [loadingMore, setLoadingMore] = useState(false);

  const [fileName, setFileName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [displayBankAccountListUpload, setDisplayBankAccountListUpload] = useState(false);

  const onClickBankAccountListUpload = (item) => {
    setDisplayBankAccountListUpload(true);
  };
  const onHideBankAccountListUpload = () => {
    setFileName("");
    setSelectedImage(null);
    setDisplayBankAccountListUpload(false);
  };


  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    ifsc: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    accountHolderName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    accountNumber: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    branch: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    category: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    info: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    upiInfo: { value: null, matchMode: FilterMatchMode.STARTS_WITH },

  });

  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [searchByStatus, setSearchByStatus] = useState('name');

  const searchByStatusData = [
    { label: "Name", value: "name"},
    { label: "IFSC", value: "ifsc"},
    { label: "Account Holder Name", value: "accountHolderName"},
    { label: "Account Number", value: "accountNumber"},
    { label: "Branch", value: "branch"},
    { label: "Category", value: "category"},
    { label: "Info", value: "info"},
    { label: "UPI Info", value: "upiInfo"},
  ];

   
  const fetchData = () => {

    getBankAccount()
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
            setProducts(newData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
  };

  useEffect(() => {
    fetchData();
  }, []);

   

  const onFilter = (event) => {
    setFilters(event.filters);

    let searchBy = "";
    let searchText = "";

    // Detect which column filter is applied
    Object.keys(event.filters).forEach((key) => {
      if (key !== "global" && event.filters[key]?.value) {
        searchBy = key;
        searchText = event.filters[key].value;
      }
    });

    fetchData();
  };

   

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    setGlobalFilterValue(value);
     
    setProducts([]);

    fetchData();
  };

  const downloadPDF = (data) => {
    if (!data || data.length === 0) return;

    const doc = new jsPDF("landscape");
    const logoImg = new Image();
    logoImg.src = logoBig;

    doc.addImage(logoImg, "PNG", 10, 5, 40, 15);
    doc.setFontSize(16);
    doc.text("CA User Data", 200, 15);

    doc.autoTable({
      head: [["ID", "Date", "Name", "Mobile", "City", "State", "Status"]],
      body: data.map((item) => [
        item.id,
        formatDate(item.createdDate),
        item.name,
        item.mobile,
        item.city,
        item.state,
        item.status ? "ACTIVE" : "INACTIVE"
      ]),
      startY: 25,
      theme: "grid",
      styles: { fontSize: 9 }
    });

    doc.save("CA-User-List.pdf");
  };

  const handleBankAccountListUpload = (event) => {
    event.preventDefault();
    const fileInput = event.target.querySelector('input[type="file"]');
    const uploadFile = fileInput.files[0];

    if (!uploadFile) {
      console.error("No file selected");
      return;
    }

    // bankAccountListUpload(uploadFile)
    //   .then((response) => {
    //     const Res = response.data;
    //     // handle the response
    //     if (Res.status === true) {
    //       successMessage("Bank List Upload Successfully " + Res.message);
    //       setFileName("");
    //       setSelectedImage(null);
    //       fetchData()
    //       setDisplayBankAccountListUpload(false);
    //     } else {
    //       errorMessage("BankAccount List Upload Failed " + Res.message);
    //       setFileName("");
    //       setSelectedImage(null);
    //       fetchData()
    //       setDisplayBankAccountListUpload(false);
    //     }
    //   })
    //   .catch((error) => {
    //     // handle errors
    //     errorMessage("BankAccount List Upload Failed");
    //     setFileName("");
    //     setSelectedImage(null);
    //     fetchData()
    //     setDisplayBankAccountListUpload(false);
    //   });
  };

  const handleBankAccountListDownload = () => {
    const link = document.createElement("a");
    link.href = "/upload_bankAccount.xlsx"; // File path inside public folder
    link.download = "upload_bankAccount.xlsx"; // Rename file on download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setFileName(file ? file.name : ""); // Update the file name or clear it if no file is selected

    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    } else {
      setSelectedImage(null);
    }
  };

  const renderDialogBankAccountUpload = () => (
    <Dialog
      header="BankAccount List Upload"
      visible={displayBankAccountListUpload}
      onHide={() => onHideBankAccountListUpload()}
      breakpoints={{ "960px": "75vw" }}
      style={{ width: "50vw" }}
    >
      <div>
        <form onSubmit={handleBankAccountListUpload}>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <button
                onClick={handleBankAccountListDownload}
                style={{
                  padding: "10px",
                  background: "blue",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Download Sample File
              </button>
            </div>
          </div>
          <div className="row mb-3">
            <div
              className="col-md-12"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div>
                <label for="file-upload" className="custom-file-upload">
                  <i className="pi pi-upload"></i> Choose BankAccount List File
                </label>
                <input
                  id="file-upload"
                  type="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
              </div>
              <div>
                <i
                  className="pi pi-file"
                  style={{ color: "blue", fontSize: "40px" }}
                ></i>
                {fileName && (
                  <p
                    style={{
                      alignSelf: "center",
                      fontSize: 14,
                      fontWeight: 600,
                      margin: 10,
                    }}
                  >
                    {fileName}
                  </p>
                )}
              </div>
            </div>
          </div>
          {selectedImage && (
            <div className="col-md-12 text-center">
              <button
                type="submit"
                className="move-btn move-btn-blue"
              >
                Submit
              </button>
            </div>
          )}
        </form>
      </div>
    </Dialog>
  );

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/masters")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Bank Account List
                </h5>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">
                    <div className="col-md mb-2">
                      <InputText
                        type="text"
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={searchByStatusData}
                        value={searchByStatus}
                        onChange={(e) => {
                          setSearchByStatus(e.value);
                        }}
                      />
                    </div>

                  </div>

                  <div className="row">
                    <div className="col-md">
                      <Link
                        to="/user-master/bank-account/create"
                        className="move-btn move-btn-blue center-text"
                      >
                        Create
                      </Link>
                    </div>
                    {/*<div className="col-md">
                      <i
                        onClick={() =>
                          onClickBankAccountListUpload(
                            "displayBankAccountListUpload"
                          )
                        }
                        className="pi pi-upload"
                        style={{
                          fontSize: "20px",
                          color: "#1e439b",
                          cursor: "pointer",
                        }}
                      ></i>
                    </div>*/}
                  </div>
                </div>
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      dataKey="id"
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rows}
                      rowsPerPageOptions={[20, 50, 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      onFilter={onFilter}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'createdDate', 'name', "mobile", "city", "state"]}
                      stripedRows
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>
                      <Column
                        field="name"
                        header="Bank Name"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.name}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="ifsc"
                        header="IFSC"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.ifsc}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="accountHolderName"
                        header="Account Holder Name"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.accountHolderName}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="accountNumber"
                        header="Account Number"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.accountNumber}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="branch"
                        header="Branch"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.branch}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="category"
                        header="Category"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.category}
                          </span>
                        )}
                      ></Column>


                     

                      <Column
                        field="info"
                        header="Info"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.info}
                          </span>
                        )}
                      ></Column>

                     

                      <Column
                        field="upiInfo"
                        header="UPI Info"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.upiInfo}
                          </span>
                        )}
                      ></Column>

                       
                      <Column
                        field="Edit"
                        header="Edit"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/user-master/bank-account/edit"}
                            state={rowData}
                            className="move-btn move-btn-yellow center-text"
                          >
                            Edit <i className="bi bi-pencil-square"></i>
                          </Link>
                        )}
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div>{renderDialogBankAccountUpload()}</div>
    </main>
  );
}
